/**
 * Wrapper around hero sections that provides the relative + overflow-hidden
 * container used across marketing pages, so Phase 3 pages can drop
 * book-scatter backgrounds in consistently.
 *
 * Props:
 *   - children
 *   - className: extra classes merged onto the <section>
 */
export default function MarketingHero({ children, className = "" }) {
  return (
    <section className={`relative overflow-hidden ${className}`.trim()}>
      {children}
    </section>
  );
}
